import { render } from "./S540_LieferantRechnungFormular.vue?vue&type=template&id=5cf37d1f&scoped=true&ts=true"
import script from "./S540_LieferantRechnungFormular.vue?vue&type=script&lang=ts"
export * from "./S540_LieferantRechnungFormular.vue?vue&type=script&lang=ts"

import "./S540_LieferantRechnungFormular.vue?vue&type=style&index=0&id=5cf37d1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf37d1f"]])

export default __exports__